import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store/store';
import { BASE_URL } from 'app/utils/utils';
import { AverageSpeedResponse, GetTargetPathResponse, OnTheMoveResponse, TravelledDistanceResponse } from 'ais-facade-api/api';
import i18next from 'i18next';
import { onQueryStartedErrorToast } from './apiErrorHandler';

export const targetApi = createApi({
  reducerPath: 'target',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL + '/facade/versions/1/',
    credentials: 'include',
    mode: 'cors',
    prepareHeaders: (headers: Headers, { getState }) => {
      const userInfo = (getState() as RootState).userSlice;
      headers.set('Accept-Language', i18next.resolvedLanguage ? i18next.resolvedLanguage : 'ru');

      if (userInfo?.auth && userInfo?.user) {
        headers.set('x-ais-user-csrf', userInfo.auth.value.csrfToken);
        headers.set('ais-user-csrf', userInfo.auth.value.csrfToken);
      }
      return headers;
    },
  }),
  tagTypes: ['Target'],
  endpoints: (build) => ({
    getVesselRoute: build.query<GetTargetPathResponse, number>({
      query: (mmsi) => ({
        url: `path/${mmsi}`,
        cache: 'no-cache',
        overrideExisting: false,
        withCredentials: true,
      }),
      onQueryStarted: onQueryStartedErrorToast,
    }),
    getTravelledDistance: build.query<TravelledDistanceResponse, { mmsi: number; from: string; to: string; datetime: string }>({
      query: ({ mmsi, from, to, datetime }) => ({
        url: `aggregate/${mmsi}/travelled-distance`,
        params: {
          from,
          to,
          datetime,
        },
      }),
      onQueryStarted: onQueryStartedErrorToast,
    }),
    getAverageSpeed: build.query<
      AverageSpeedResponse,
      { mmsi: number; from: string; to: string; mode: string; datetime: string }
    >({
      query: ({ mmsi, from, to, datetime, mode }) => ({
        url: `aggregate/${mmsi}/average-speed`,
        params: {
          from,
          to,
          datetime,
          mode,
        },
      }),
      onQueryStarted: onQueryStartedErrorToast,
    }),
    getOnTheMove: build.query<OnTheMoveResponse, { mmsi: number; from: string; to: string; datetime: string }>({
      query: ({ mmsi, from, to, datetime }) => ({
        url: `aggregate/${mmsi}/on-the-move`,
        params: {
          from,
          to,
          datetime,
        },
      }),
      onQueryStarted: onQueryStartedErrorToast,
    }),
  }),
});

export const { useLazyGetVesselRouteQuery, useGetTravelledDistanceQuery, useGetAverageSpeedQuery, useGetOnTheMoveQuery } =
  targetApi;
